import JsBarcode from 'jsbarcode'
import { useEffect, useRef } from 'react'

export function RoutingBarcode({rxid}:{rxid:string}){
  const ref=useRef<SVGSVGElement>(null)
  useEffect(()=>{
    if(!ref.current)return
    JsBarcode(ref.current,rxid,{format:'CODE128',displayValue:false,height:52,width:2,margin:0,lineColor:'#0B1524',background:'#FFFFFF'})
  },[rxid])
  return <svg ref={ref} className="routing-barcode" role="img" aria-label={`Barcode encoding routing ID ${rxid}`}/>
}
